function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    .cls-2 { isolation: isolate; }\n  "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4701",
  "data-name": "Group 4701"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1937",
  "data-name": "Group 1937"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1948",
  "data-name": "Group 1948"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_28",
  "data-name": "Ellipse 28"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M33.7,27.49A4.34,4.34,0,1,1,38,23.15,4.34,4.34,0,0,1,33.7,27.49Zm0-6.67A2.34,2.34,0,1,0,36,23.15,2.33,2.33,0,0,0,33.7,20.82Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_29",
  "data-name": "Ellipse 29"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M192.74,77.3A4.34,4.34,0,1,1,197.08,73,4.34,4.34,0,0,1,192.74,77.3Zm0-6.67A2.34,2.34,0,1,0,195.08,73,2.34,2.34,0,0,0,192.74,70.63Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1941",
  "data-name": "Group 1941"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line_262",
  "data-name": "Line 262"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 161.74,
  y: 22.63,
  width: 8.4,
  height: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Line_263",
  "data-name": "Line 263"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 164.94,
  y: 19.43,
  width: 2,
  height: 8.4
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1944",
  "data-name": "Group 1944"
}, /*#__PURE__*/React.createElement("g", {
  id: "Line_268",
  "data-name": "Line 268"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3.55,
  y: 118.75,
  width: 8.43,
  height: 2,
  transform: "translate(-0.58 0.04) rotate(-0.28)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Line_269",
  "data-name": "Line 269"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3.55,
  y: 118.75,
  width: 8.43,
  height: 2,
  transform: "translate(-112.01 126.93) rotate(-89.72)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1945",
  "data-name": "Group 1945"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_315",
  "data-name": "Path 315"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M116.09,14c-2.52-.62-3.34-2.83-4-4.61s-1.19-3-2.61-3.36-2.38.44-3.85,1.77-3.13,2.86-5.66,2.24-3.35-2.83-4-4.6-1.18-3-2.6-3.37S91,2.53,89.51,3.86,86.37,6.72,83.84,6.1l.48-1.94c1.42.35,2.38-.45,3.84-1.78S91.31-.49,93.84.14s3.34,2.83,4,4.61,1.18,3,2.6,3.36,2.39-.45,3.85-1.78S107.43,3.47,110,4.1s3.34,2.83,4,4.6,1.19,3,2.61,3.36Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1946",
  "data-name": "Group 1946"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_316",
  "data-name": "Path 316"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M33.11,74.4c-2.6,0-3.91-2-5-3.54s-1.84-2.64-3.31-2.64-2.21,1-3.3,2.64-2.37,3.54-5,3.54-3.92-2-5-3.54-1.85-2.64-3.31-2.64-2.21,1-3.31,2.64S2.6,74.4,0,74.4v-2c1.46,0,2.21-1,3.31-2.65s2.37-3.53,5-3.53,3.91,2,5,3.53,1.84,2.65,3.31,2.65,2.21-1,3.3-2.65,2.37-3.53,5-3.53,3.92,2,5,3.53,1.84,2.65,3.3,2.65Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1947",
  "data-name": "Group 1947"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_317",
  "data-name": "Path 317"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M206.1,131.53c-2.25-1.31-2.41-3.66-2.53-5.55s-.28-3.21-1.55-4-2.41-.25-4.18.62-3.82,1.88-6.08.55-2.4-3.66-2.53-5.55-.27-3.21-1.54-4-2.42-.25-4.19.62-3.81,1.88-6.07.56l1-1.73c1.27.74,2.41.25,4.18-.62s3.82-1.88,6.08-.55,2.4,3.66,2.53,5.55.27,3.22,1.54,4,2.42.25,4.19-.62,3.81-1.87,6.07-.55,2.41,3.66,2.53,5.55.28,3.21,1.55,4Z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4611",
  "data-name": "Group 4611"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_92",
  "data-name": "Ellipse 92"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M103.05,141.84a50.5,50.5,0,1,1,50.5-50.5A50.56,50.56,0,0,1,103.05,141.84Zm0-97a46.5,46.5,0,1,0,46.5,46.5A46.55,46.55,0,0,0,103.05,44.84Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "E",
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M89.09,112.06V73.3h29.48v3.47H92.86V90.11h21.55v3.48H92.86v15h25.71v3.48Z"
}))))));

var SvgParkingIcon = function SvgParkingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 207.11 141.84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParkingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parking-icon.1f67cbeb.svg";
export { ForwardRef as ReactComponent };